// extracted by mini-css-extract-plugin
export default {"tableWrapper":"mediaChannelTable_tableWrapper__chD3C","mediaChannelTable":"mediaChannelTable_mediaChannelTable__jrz4+"};